module.exports = __webpack_public_path__ + "img/darkblue_online.22309bd3.png";